import { ICarrierApplicationStates } from 'types/graphqlTypes'
import { IExtendedScorecardProps } from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard'
import { ERateRank } from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard/types'
import { capitalize } from 'utils/capitalize'
import { useCarrierScorecardInformationQuery } from '../graphql/CarrierscorecardInformation'

interface ICarrierExtendedInfoHook {
  data: IExtendedScorecardProps
  refetch: () => void
  loading: boolean
}

export function calculateRate(overallScore: number): ERateRank {
  if (overallScore === 5) {
    return ERateRank.TOP_TIER
  }
  if (overallScore >= 4.0 && overallScore <= 4.99) {
    return ERateRank.GOOD
  }
  if (overallScore >= 3.0 && overallScore <= 3.99) {
    return ERateRank.FAIR
  }
  if (overallScore >= 2.0 && overallScore <= 2.99) {
    return ERateRank.NEEDS_IMPROVEMENT
  }
  if (overallScore >= 1.0 && overallScore <= 1.99) {
    return ERateRank.POOR
  }
  return ERateRank.WEIGHTING
}

export function useShipmentCarrierExtendedInformation(carrierId: string): ICarrierExtendedInfoHook {
  const { data, loading, refetch } = useCarrierScorecardInformationQuery({
    variables: {
      id: carrierId,
    },
  })
  const { carrierApplication } = data ?? {}
  const { carrierScorecard, dotNumber, headquarter, mcNumber, name, state, totalShipments } =
    carrierApplication ?? {}
  const { bouncePct, onTimePct, overallScore, stale, trackingPct } = carrierScorecard ?? {}
  const { city, stateCode = '' } = headquarter ?? {}
  const cityName = capitalize(city ?? '').replace(/\s*,\s*/g, '')
  const stateValidCode = stateCode.toUpperCase()
  const hqValue = `${cityName}${cityName ? ', ' : ''}${stateValidCode}`

  const rate = stale ? ERateRank.WEIGHTING : calculateRate(overallScore ?? 0)
  const carrierScore = stale ? null : overallScore ?? null
  const bounceRate = stale ? null : bouncePct ?? null
  const onTimeRate = stale ? null : onTimePct ?? null
  const trackingRate = stale ? null : trackingPct ?? null

  return {
    loading,
    refetch,
    data: {
      carrierName: name ?? '',
      mcNumber: mcNumber ?? '',
      dotNumber: dotNumber ?? '',
      status: state ?? ICarrierApplicationStates.other,
      rate,
      carrierScore,
      bounceRate,
      onTimeRate,
      trackingRate,
      shipmentsCount: totalShipments ?? 0,
      hqValue,
    },
  }
}
